import { footer } from './components.module.css';

export const CreateOfferFooter = ({ children }: { children: React.ReactNode }) => (
  <footer className={footer}>{children}</footer>
);
